'use client'

// src/Switch/Switch.classes.ts
var switchSizeClasses = {
  S: "h-5 w-[33px]",
  M: "h-6 w-[42px]",
  L: "h-8 w-[52px]"
};
var thumbSizeClasses = {
  S: "h-[18px] w-[18px] data-[state=checked]:ltr:translate-x-[14px] data-[state=checked]:rtl:-translate-x-[14px]",
  M: "h-[22px] w-[22px] data-[state=checked]:ltr:translate-x-[19px] data-[state=checked]:rtl:-translate-x-[19px]",
  L: "h-[26px] w-[26px] data-[state=checked]:ltr:translate-x-[23px] data-[state=checked]:rtl:-translate-x-[23px]"
};
var switchThemeClasses = {
  primary: "data-[state=checked]:bg-primary",
  secondary: "data-[state=checked]:bg-secondary",
  action: "data-[state=checked]:bg-action"
};
var thumbThemeClasses = {
  primary: "data-[state=checked]:bg-primary-contrast",
  secondary: "data-[state=checked]:bg-secondary-contrast",
  action: "data-[state=checked]:bg-action-contrast"
};

export {
  switchSizeClasses,
  thumbSizeClasses,
  switchThemeClasses,
  thumbThemeClasses
};
//# sourceMappingURL=chunk-Z3WDDEXB.mjs.map